module.exports = __webpack_public_path__ + "static/media/boxes-alt.32a280dd.svg";